// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".red {\n  background-color: red;\n}\n.yellow {\n  background-color: #ffff13;\n}\n.green {\n  background-color: #2eeb2e;\n}\n.orange {\n  background-color: orange;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
